import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  href: "/notifications",
  class: "d-inline-flex align-items-center btn btn-light position-relative d-md-none d-lg-none p-0 border-0 bg-transparent"
}
const _hoisted_2 = {
  class: "badge badge-notification badge-primary bg-primary d-lg-none",
  style: {"top":"0","right":"0","transform":"translate(-30%, -30%)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([{ invisible: !_ctx.visible }, "d-lg-none"])
  }, [
    _createElementVNode("a", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-bell fs-3 d-lg-none" }, null, -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.state.display.value), 1)
    ])
  ], 2))
}